import React from "react";
import { Trash2, X, AlertTriangle } from "lucide-react";
import "../DuelSkin/aduanaSkin.css";

export const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "¿Eliminar discusión?",
  description = "Esta acción no se puede deshacer y eliminará permanentemente la discusión y todas sus respuestas.",
  isDeleting = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="battle-modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.78)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflowY: "auto",
        zIndex: 99999,
        padding: "16px",
      }}
      onClick={!isDeleting ? onClose : undefined}
    >
      <div
        className="duel-skin-root duel-skin-modal-box"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          maxWidth: "480px",
          width: "100%",
          margin: "auto",
          border: "1px solid rgba(226, 85, 74, 0.45)",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.7), 0 0 30px rgba(226, 85, 74, 0.15)",
        }}
      >
        {/* Radar backdrop from BattleModal */}
        <div className="duel-skin-radar-field">
          <div className="duel-skin-radar-sweep"></div>
          <div className="duel-skin-scanline"></div>
        </div>

        {/* Close Button */}
        <button
          className="battle-modal-close duel-skin-close-btn"
          onClick={onClose}
          disabled={isDeleting}
          aria-label="Cerrar modal"
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            background: "none",
            border: "none",
            color: "var(--duel-skin-text-dim, #7f95a6)",
            cursor: isDeleting ? "not-allowed" : "pointer",
            padding: "4px",
            zIndex: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "color 0.2s",
          }}
          onMouseEnter={(e) => {
            if (!isDeleting) e.currentTarget.style.color = "#ffffff";
          }}
          onMouseLeave={(e) => {
            if (!isDeleting) e.currentTarget.style.color = "var(--duel-skin-text-dim, #7f95a6)";
          }}
        >
          <X size={20} />
        </button>

        {/* Content container (elevated above radar) */}
        <div style={{ position: "relative", zIndex: 2 }}>
          {/* Tag */}
          <span
            className="duel-skin-tag"
            style={{
              color: "var(--duel-skin-danger, #e2554a)",
              display: "inline-block",
              marginBottom: "12px",
            }}
          >
            CONFIRMACIÓN REQUERIDA
          </span>

          {/* Danger Icon Badge */}
          <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: "rgba(226, 85, 74, 0.12)",
              border: "1px solid rgba(226, 85, 74, 0.35)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
              color: "var(--duel-skin-danger, #e2554a)",
            }}
          >
            <Trash2 size={28} />
          </div>

          {/* Hero Title */}
          <h2
            className="duel-skin-hero-face"
            style={{
              fontSize: "var(--font-size-md, 18px)",
              margin: "0 0 12px",
              color: "var(--duel-skin-text, #eef1ea)",
              letterSpacing: "-0.01em",
            }}
          >
            {title}
          </h2>

          {/* Description */}
          <p
            style={{
              color: "var(--duel-skin-text-dim, #7f95a6)",
              fontSize: "var(--font-size-min, 15px)",
              lineHeight: 1.5,
              margin: "0 0 24px",
              padding: "0 8px",
            }}
          >
            {description}
          </p>

          {/* Action Buttons */}
          <div
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              onClick={onClose}
              disabled={isDeleting}
              style={{
                flex: 1,
                padding: "12px 18px",
                borderRadius: "4px",
                border: "1px solid var(--duel-skin-line, rgba(210,167,72,0.22))",
                backgroundColor: "var(--duel-skin-panel, #0b1620)",
                color: "var(--duel-skin-text-dim, #7f95a6)",
                fontFamily: "ui-monospace, monospace",
                fontSize: "var(--font-size-min, 15px)",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                cursor: isDeleting ? "not-allowed" : "pointer",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => {
                if (!isDeleting) {
                  e.currentTarget.style.borderColor = "var(--duel-skin-line-strong, rgba(210,167,72,0.4))";
                  e.currentTarget.style.color = "var(--duel-skin-text, #eef1ea)";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "var(--duel-skin-line, rgba(210,167,72,0.22))";
                e.currentTarget.style.color = "var(--duel-skin-text-dim, #7f95a6)";
              }}
            >
              Cancelar
            </button>

            <button
              type="button"
              onClick={onConfirm}
              disabled={isDeleting}
              style={{
                flex: 1,
                padding: "12px 18px",
                borderRadius: "4px",
                border: "1px solid var(--duel-skin-danger, #e2554a)",
                backgroundColor: "rgba(226, 85, 74, 0.2)",
                color: "#ff7b72",
                fontFamily: "ui-monospace, monospace",
                fontSize: "var(--font-size-min, 15px)",
                fontWeight: 700,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                cursor: isDeleting ? "not-allowed" : "pointer",
                transition: "all 0.15s ease",
                boxShadow: "0 0 16px rgba(226, 85, 74, 0.25)",
              }}
              onMouseEnter={(e) => {
                if (!isDeleting) {
                  e.currentTarget.style.backgroundColor = "var(--duel-skin-danger, #e2554a)";
                  e.currentTarget.style.color = "#ffffff";
                  e.currentTarget.style.boxShadow = "0 0 24px rgba(226, 85, 74, 0.5)";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(226, 85, 74, 0.2)";
                e.currentTarget.style.color = "#ff7b72";
                e.currentTarget.style.boxShadow = "0 0 16px rgba(226, 85, 74, 0.25)";
              }}
            >
              {isDeleting ? "Eliminando..." : "Sí, eliminar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
